import React from 'react';


const Admin_Commodity_ui=()=>{

    return(<div>1</div>)

}


export default Admin_Commodity_ui;